import React from 'react';
import {
  Button,
  CondensedLabel,
  CondensedMedium,
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  Well,
} from '@axiom/ui';
import type { OpportunityCandidate } from '@axiom/validation';

import type { OpportunitySubmissionCandidateRateSchemaType } from './opportunity-submission-candidate-rate-schema';
import { OpportunitySubmissionCandidateRateCpqIndicator } from './OpportunitySubmissionCandidateRateCpqIndicator';
import { OpportunitySubmissionCandidateRateUtil } from './opportunity-submission-candidate-rate-util';

export type OpportunitySubmissionCandidateRateCpqTargetsProps = {
  opportunityCandidate: OpportunityCandidate;
  onReset: () => void;
  readOnly: boolean;
  resetDisabled: boolean;
  values: Partial<OpportunitySubmissionCandidateRateSchemaType>;
};

export const OpportunitySubmissionCandidateRateCpqTargets = ({
  opportunityCandidate,
  onReset,
  readOnly,
  resetDisabled,
  values,
}: OpportunitySubmissionCandidateRateCpqTargetsProps) => {
  const {
    marginApprovalCeiling,
    marginApprovalFloor,
    marginFloorPct,
    marginUpperPct,
  } = opportunityCandidate;
  const cpqTargetsUnavailable =
    OpportunitySubmissionCandidateRateUtil.isCpqTargetsUnavailable({
      opportunityCandidate,
    });

  return (
    <Well background="light">
      <Grid>
        <GridRow columns={2} verticalAlign="middle">
          <GridColumn width={5} verticalAlign="middle">
            <CondensedLabel>CPQ Targets:</CondensedLabel>
          </GridColumn>
          <GridColumn width={7} verticalAlign="bottom" name="cpq-targets-value">
            <CondensedMedium>
              {cpqTargetsUnavailable
                ? '-'
                : `${marginFloorPct}% - ${marginUpperPct}%`}
            </CondensedMedium>
          </GridColumn>
        </GridRow>
      </Grid>
      {marginApprovalFloor && marginApprovalCeiling ? (
        <Gutter top="8px">
          <OpportunitySubmissionCandidateRateCpqIndicator
            values={values}
            opportunityCandidate={opportunityCandidate}
          />
        </Gutter>
      ) : null}
      {readOnly ? null : (
        <Gutter top="8px">
          <Button
            name="reset-button"
            pattern="secondary"
            variation="outline"
            disabled={resetDisabled}
            onClick={() => {
              onReset();
            }}
          >
            RESET
          </Button>
        </Gutter>
      )}
    </Well>
  );
};
